import { useState, useEffect } from 'react'
import { Box, Text, Link } from '@primer/react'

function Footer() {
    return (
        <Box sx={{ textAlign: 'center' }}>
            <Text>
                2024 | <Link href="https://github.com/mbiemann" target="_blank">@mbiemann</Link>
            </Text>
        </Box>
    )
}

export default function Home() {
    const [displayText, setDisplayText] = useState('')
    const text = 'Hello there, thanks for visiting! This app is under construction. Please, check back later.'

    useEffect(() => {
        if (displayText.length < text.length)
            setTimeout(() => setDisplayText((prev) => prev + text.slice(prev.length, prev.length + 1)), 50)
        else
            setTimeout(() => {setDisplayText('')}, 2500)
    }, [displayText]);

    return (
        <Box
            sx={{
                bg: 'canvas.default',
                width: '100%',
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                p: 5,
            }}
        >
            <Box
                sx={{
                    maxWidth: 400,
                    width: '100%',
                    height: 200,
                    borderRadius: 2,
                    p: 4,
                    my: 6,
                    border: '1px solid',
                }}
            >
                <Text>{displayText}</Text>
            </Box>
            <Footer />
        </Box>
    )
}
